/* ============================================================================
   ad-rc-enhance.js: Ring Configurator 5-Pack (B1, B2, B3, B6, B7)
   Companion module for sections/ad-ring-configurator.liquid (Alpine root
   `adRingConfigurator()`). Attaches WITHOUT modifying the protected core:
   it reads/writes the live Alpine state via Alpine.$data and injects its own
   UI at stable mount points.

   B1  State persistence  : localStorage save/restore + "Resume your ring" banner
   B2  Shareable URL      : base64url encode/decode of selections + "Share this ring"
   B3  Contact pre-fill   : spec via URL params + hidden contact[*] fields + body prefill
   B6  Estimated price band: stone price + The Setting min/max (metafield-backed, JS fallback)
   B7  WhatsApp handoff CTA: wa.me/16893323473?text=<spec>

   Voice: no em dashes anywhere. Load DEFERRED, after the configurator script.
   Site-wide safe: it no-ops when neither the configurator nor ?ring_spec is present.
   ============================================================================ */
(function () {
  'use strict';

  var WA_NUMBER = '16893323473';
  var LS_KEY    = 'ad_rc_state_v1';
  var SHARE_PARAM = 'ring';
  var SPEC_PARAM  = 'ring_spec';
  var MAX_AGE_MS  = 14 * 24 * 60 * 60 * 1000; /* 14 days */

  /* State keys we persist / share (selectedDiamond handled separately) */
  var KEYS = [
    'currentStep', 'selectedShape', 'colorType', 'fancyColor', 'qualityTier',
    'caratMin', 'caratMax', 'budgetMin', 'budgetMax',
    'selectedSetting', 'selectedMetal', 'ringSize', 'sizeUnknown',
    'engravingText', 'engravingFont', 'inspirationUrl', 'inspirationNotes'
  ];

  /* The Setting price range. Seeded from metafields (800/2550); refreshed from
     the live product so it never drifts from real variant prices. */
  var settingRange = { min: 800, max: 2550 };

  /* ---------- helpers ---------------------------------------------------- */
  function b64e(str) {
    return btoa(unescape(encodeURIComponent(str)))
      .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function b64d(str) {
    str = String(str).replace(/-/g, '+').replace(/_/g, '/');
    while (str.length % 4) str += '=';
    return decodeURIComponent(escape(atob(str)));
  }
  function money(n) {
    n = Number(n) || 0;
    return '$' + n.toLocaleString('en-US', { maximumFractionDigits: 0 });
  }
  function num(v) { return parseFloat(String(v).replace(/[^0-9.]/g, '')) || 0; }
  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }

  function getRoot() { return document.querySelector('[x-data^="adRingConfigurator"]'); }
  function getData(root) {
    try { return (window.Alpine && root) ? Alpine.$data(root) : null; } catch (e) { return null; }
  }

  /* Wait for Alpine + the component instance to be live */
  function whenReady(cb) {
    var tries = 0;
    (function poll() {
      var root = getRoot();
      var d = getData(root);
      if (d && typeof d.currentStep !== 'undefined') return cb(root, d);
      if (++tries > 60) return; /* ~12s then give up */
      setTimeout(poll, 200);
    })();
  }

  /* ---------- snapshot / restore (B1 + B2 shared) ------------------------ */
  function snapshot(d) {
    var s = {};
    KEYS.forEach(function (k) { if (typeof d[k] !== 'undefined') s[k] = d[k]; });
    s.selectedDiamond = d.selectedDiamond || null;
    s.savedAt = Date.now();
    return s;
  }
  function applyState(d, s) {
    if (!s) return;
    KEYS.forEach(function (k) { if (typeof s[k] !== 'undefined') d[k] = s[k]; });
    if (s.selectedDiamond) d.selectedDiamond = s.selectedDiamond;
    /* Unlock navigation: goToStep guards on maxReachedStep */
    var step = s.currentStep || 1;
    if (typeof d.maxReachedStep !== 'undefined') {
      d.maxReachedStep = Math.max(d.maxReachedStep || 1, step);
    }
    d.currentStep = step;
    if (typeof d.recountMatches === 'function') { try { d.recountMatches(); } catch (e) {} }
  }

  /* ---------- spec building (B3 + B7) ------------------------------------ */
  function specLines(d) {
    var L = [];
    function row(label, val) { if (val) L.push(label + ': ' + val); }
    try {
      var shape = (d.shapes || []).find(function (s) { return s.key === d.selectedShape; });
      row('Shape', shape && shape.label);
      var dia = d.selectedDiamondFormatted;
      row('Diamond', dia && dia.specs);
      row('Stone ID', d.selectedDiamond && d.selectedDiamond.stoneId);
      row('Setting', d.selectedSettingInfo && d.selectedSettingInfo.label);
      row('Metal', d.selectedMetalInfo && d.selectedMetalInfo.label);
      row('Ring size', d.ringSizeLabel);
      if (d.engravingText && d.engravingText.trim()) row('Engraving', d.engravingText.trim());
      row('Estimated total', d.totalPriceFormatted);
    } catch (e) {}
    return L;
  }
  function specText(d) {
    var L = specLines(d);
    return L.length
      ? ('My ring so far:\n' + L.join('\n') + '\n\nI would like to talk it through with Dave.')
      : 'I am designing a ring and would like to talk it through with Dave.';
  }

  /* ============================ B6: PRICE BAND =========================== */
  function refreshSettingRange() {
    fetch('/products/ad-ring-setting.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants || !p.variants.length) return;
        var prices = p.variants.map(function (v) { return (v.price || 0) / 100; });
        settingRange.min = Math.min.apply(null, prices);
        settingRange.max = Math.max.apply(null, prices);
      })
      .catch(function () {});
  }
  function mountPriceBand(root) {
    var anchor = root.querySelector('.ad-rc-preview__price');
    if (!anchor || root.querySelector('.ad-rce-band')) return;
    var band = el('div', 'ad-rce-band', '');
    band.style.display = 'none';
    anchor.insertAdjacentElement('afterend', band);
  }
  function updatePriceBand(root, d) {
    var band = root.querySelector('.ad-rce-band');
    if (!band) return;
    var stone = d.selectedDiamond ? num(d.selectedDiamond.price) : 0;
    /* Show the band once a stone is chosen but the exact setting+metal is not,
       then defer to the configurator's exact total. */
    var settingChosen = d.selectedSetting && d.selectedMetal;
    if (!stone || settingChosen) { band.style.display = 'none'; return; }
    var low  = stone + settingRange.min;
    var high = stone + settingRange.max;
    band.innerHTML =
      '<span class="ad-rce-band__label">Estimated complete ring</span>' +
      '<span class="ad-rce-band__val">' + money(low) + ' to ' + money(high) + '</span>' +
      '<span class="ad-rce-band__note">Depending on the setting you choose. Confirmed with Dave.</span>';
    band.style.display = 'block';
  }

  /* ====================== B2 + B7 + B3: ACTION BAR ====================== */
  function mountActions(root, d) {
    if (root.querySelector('.ad-rce-actions')) return;
    /* Find the Proceed to Checkout button (inside the step-6 review block) */
    var cartBtn = null;
    root.querySelectorAll('button').forEach(function (b) {
      var h = b.getAttribute('@click') || b.getAttribute('x-on:click') || '';
      if (h.indexOf('addToCart') > -1) cartBtn = b;
    });
    if (!cartBtn) return;

    var wrap = el('div', 'ad-rce-actions', '');
    var share = el('button', 'ad-rce-btn ad-rce-btn--ghost', 'Share this ring');
    share.type = 'button';
    var wa = el('a', 'ad-rce-btn ad-rce-btn--wa', 'Text Dave');
    wa.target = '_blank'; wa.rel = 'noopener';
    var cont = el('a', 'ad-rce-btn ad-rce-btn--ghost', 'Continue with Dave');

    wrap.appendChild(share); wrap.appendChild(wa); wrap.appendChild(cont);
    cartBtn.insertAdjacentElement('afterend', wrap);

    /* B2: Share this ring */
    share.addEventListener('click', function () {
      var url = location.origin + location.pathname + '?' + SHARE_PARAM + '=' + b64e(JSON.stringify(snapshot(d)));
      var done = function () {
        var prev = share.textContent; share.textContent = 'Link copied';
        setTimeout(function () { share.textContent = prev; }, 1800);
      };
      if (navigator.share) {
        navigator.share({ title: 'My ring at Atelier Diamante', url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(done, done);
      } else { prompt('Copy your ring link:', url); }
    });

    /* refs updated live in the tick loop */
    wrap._wa = wa; wrap._cont = cont; wrap._d = d;
  }
  function updateActions(root, d) {
    var wrap = root.querySelector('.ad-rce-actions');
    if (!wrap) return;
    var txt = specText(d);
    if (wrap._wa)   wrap._wa.href = 'https://wa.me/' + WA_NUMBER + '?text=' + encodeURIComponent(txt);
    if (wrap._cont) {
      var u = '/pages/contact?' + SPEC_PARAM + '=' + encodeURIComponent(txt) +
              '&' + SHARE_PARAM + '=' + b64e(JSON.stringify(snapshot(d)));
      wrap._cont.href = u;
    }
  }

  /* ============================ B1: RESUME BANNER ======================= */
  function mountResumeBanner(root, d) {
    var raw;
    try { raw = JSON.parse(localStorage.getItem(LS_KEY) || 'null'); } catch (e) { raw = null; }
    if (!raw || !raw.savedAt || (Date.now() - raw.savedAt) > MAX_AGE_MS) return;
    /* Only offer resume if there is something worth resuming and we did not
       arrive via a share link (that path restores directly). */
    if (new URLSearchParams(location.search).get(SHARE_PARAM)) return;
    if (!raw.selectedShape && !raw.selectedDiamond) return;

    var banner = el('div', 'ad-rce-resume', '');
    banner.innerHTML =
      '<span class="ad-rce-resume__txt">Welcome back. Pick up where you left off on your ring.</span>';
    var resume = el('button', 'ad-rce-btn ad-rce-btn--gold', 'Resume your ring'); resume.type = 'button';
    var fresh  = el('button', 'ad-rce-btn ad-rce-btn--text', 'Start fresh');       fresh.type = 'button';
    banner.appendChild(resume); banner.appendChild(fresh);
    root.insertBefore(banner, root.firstChild);

    resume.addEventListener('click', function () { applyState(d, raw); banner.remove(); });
    fresh.addEventListener('click', function () {
      try { localStorage.removeItem(LS_KEY); } catch (e) {}
      banner.remove();
    });
  }

  /* ====================== B2: restore from share link =================== */
  function restoreFromShare(d) {
    var q = new URLSearchParams(location.search).get(SHARE_PARAM);
    if (!q) return;
    try { applyState(d, JSON.parse(b64d(q))); } catch (e) {}
  }

  /* ======================= B3: contact-page pre-fill ==================== */
  /* Runs everywhere (no Alpine needed). Fills the Shopify contact form from
     ?ring_spec and adds structured hidden contact[*] fields. */
  function contactPrefill() {
    var spec = new URLSearchParams(location.search).get(SPEC_PARAM);
    if (!spec) return;
    var form = document.querySelector('form[action*="/contact"]') ||
               document.getElementById('ContactForm');
    if (!form) return;
    var body = form.querySelector('textarea[name="contact[body]"], textarea#ContactForm-body');
    if (body && !body.value.trim()) body.value = spec;
    /* Hidden structured field so Dave receives the spec even if the body is edited */
    if (!form.querySelector('input[name="contact[Ring Spec]"]')) {
      var h = document.createElement('input');
      h.type = 'hidden'; h.name = 'contact[Ring Spec]'; h.value = spec;
      form.appendChild(h);
    }
  }

  /* ============================ tick loop =============================== */
  function startLoop(root, d) {
    var last = '';
    setInterval(function () {
      /* B1 persist on change */
      try {
        var snap = JSON.stringify(snapshot(d));
        if (snap !== last && (d.selectedShape || d.selectedDiamond)) {
          last = snap;
          localStorage.setItem(LS_KEY, snap);
        }
      } catch (e) {}
      updatePriceBand(root, d);
      updateActions(root, d);
    }, 800);
  }

  /* ============================ boot =================================== */
  function init() {
    contactPrefill(); /* contact page path, configurator-independent */
    whenReady(function (root, d) {
      refreshSettingRange();
      restoreFromShare(d);   /* B2 inbound */
      mountResumeBanner(root, d); /* B1 */
      mountPriceBand(root);  /* B6 */
      mountActions(root, d); /* B2 + B3 + B7 */
      startLoop(root, d);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
